import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/client';

const DEFAULT_TITLE = 'Magtic Parduotuvė';

function DocumentTitle() {
  const location = useLocation();
  const { data: settings } = useQuery({
    queryKey: ['store-settings'],
    queryFn: async () => {
      const res = await apiClient.get('/store-settings');
      return res.data;
    },
  });

  useEffect(() => {
    // Produkto puslapis nustato savo title (ProductDetail) – neperrašome
    const isProductDetail = /^\/products\/[^/]+$/.test(location.pathname);
    if (isProductDetail) return;

    const title = (settings?.store_title || '').trim() || DEFAULT_TITLE;
    document.title = title;
  }, [location.pathname, settings?.store_title]);

  return null;
}

export default DocumentTitle;
